import React, { memo } from 'react';
import { Button } from '../../../../components';

export const MissingOrInvalidFiles = memo(({ error, resetForm }) => {
    return (
        <div className="missing-or-invalid-files">
            {error.message}
            <div className="button-group">
                <Button type="primary" size="medium" onClick={resetForm}>
                    Start Over
                </Button>
            </div>
        </div>
    );
});
